import { Box, BoxProps } from '@mui/material';

interface HotKeyBoxProps {
  hotkeyDisplay: React.ReactNode;
  backgroundColor?: BoxProps['bgcolor'];
  isDisabled?: boolean;
}

export const HotKeyBox = ({
  hotkeyDisplay,
  backgroundColor,
  isDisabled,
}: HotKeyBoxProps) => {
  return (
    <Box
      component="span"
      bgcolor={
        backgroundColor ||
        (isDisabled ? 'misc.hotKey.disabled' : 'misc.hotKey.primary')
      }
      px={0.5}
      borderRadius={0.5}
      textTransform="none"
      style={{ fontSize: 'small' }}
    >
      {hotkeyDisplay}
    </Box>
  );
};
